<ng-template #content>
  <ng-content></ng-content>
</ng-template>

<ng-template #title>
  <div class="heading" [ngClass]="{ isChild: isChild, isExpanded: isExpanded }">
    <ng-content *ngIf="!heading" select="[uni-accordion-heading]"></ng-content>

    {{ heading }}

    <button uni-icon-button [variant]="isChild && isExpanded ? 'white' : 'primary'" *ngIf="showExpandedIcon">
      <uni-icon [name]="isExpanded ? 'minus' : 'plus'"></uni-icon>
    </button>
  </div>
</ng-template>
